export default __webpack_public_path__ + "static/rifle-home-2x-e4ef418faf00bbb622a30f9027f934a5.png";